// AUTO-GENERATED CODE. DO NOT MODIFY!
"use strict";
var apsEnums;
(function (apsEnums) {
    var FrequencyType;
    (function (FrequencyType) {
        FrequencyType[FrequencyType["None"] = 0] = "None";
        FrequencyType[FrequencyType["Count"] = 1] = "Count";
        FrequencyType[FrequencyType["Percentage"] = 2] = "Percentage";
        FrequencyType[FrequencyType["PSI"] = 3] = "PSI";
        FrequencyType[FrequencyType["ThermalShock"] = 4] = "ThermalShock";
    })(FrequencyType = apsEnums.FrequencyType || (apsEnums.FrequencyType = {}));
    var Severity;
    (function (Severity) {
        Severity[Severity["Critical"] = 0] = "Critical";
        Severity[Severity["Major"] = 1] = "Major";
        Severity[Severity["Minor"] = 2] = "Minor";
        Severity[Severity["Event"] = 3] = "Event";
    })(Severity = apsEnums.Severity || (apsEnums.Severity = {}));
    var ToolChangeReason;
    (function (ToolChangeReason) {
        ToolChangeReason[ToolChangeReason["FixDefect"] = 0] = "FixDefect";
        ToolChangeReason[ToolChangeReason["SectionChange"] = 1] = "SectionChange";
        ToolChangeReason[ToolChangeReason["JobChange"] = 2] = "JobChange";
        ToolChangeReason[ToolChangeReason["Other"] = 3] = "Other";
        ToolChangeReason[ToolChangeReason["Dirty"] = 4] = "Dirty";
        ToolChangeReason[ToolChangeReason["Broken"] = 5] = "Broken";
        ToolChangeReason[ToolChangeReason["Worn"] = 6] = "Worn";
        ToolChangeReason[ToolChangeReason["Burned"] = 7] = "Burned";
        ToolChangeReason[ToolChangeReason["WrongNumber"] = 8] = "WrongNumber";
        ToolChangeReason[ToolChangeReason["NewEquipment"] = 9] = "NewEquipment";
        ToolChangeReason[ToolChangeReason["Sticky"] = 10] = "Sticky";
        ToolChangeReason[ToolChangeReason["Plugged"] = 11] = "Plugged";
        ToolChangeReason[ToolChangeReason["MoldSwap"] = 12] = "MoldSwap";
    })(ToolChangeReason = apsEnums.ToolChangeReason || (apsEnums.ToolChangeReason = {}));
    var ToolType;
    (function (ToolType) {
        ToolType[ToolType["Mold"] = 0] = "Mold";
        ToolType[ToolType["Variable"] = 1] = "Variable";
        ToolType[ToolType["Machine"] = 2] = "Machine";
    })(ToolType = apsEnums.ToolType || (apsEnums.ToolType = {}));
    var NotificationType;
    (function (NotificationType) {
        NotificationType[NotificationType["Unknown"] = 0] = "Unknown";
        NotificationType[NotificationType["Requalification"] = 1] = "Requalification";
        NotificationType[NotificationType["CheckList"] = 2] = "CheckList";
        NotificationType[NotificationType["CheckListSignOff"] = 3] = "CheckListSignOff";
        NotificationType[NotificationType["General"] = 4] = "General";
        NotificationType[NotificationType["CriticalDefect"] = 5] = "CriticalDefect";
        NotificationType[NotificationType["SectionChange"] = 6] = "SectionChange";
        NotificationType[NotificationType["CheckListEdited"] = 7] = "CheckListEdited";
        NotificationType[NotificationType["WeightAlarm"] = 8] = "WeightAlarm";
        NotificationType[NotificationType["EquipmentHealthNotification"] = 9] = "EquipmentHealthNotification";
    })(NotificationType = apsEnums.NotificationType || (apsEnums.NotificationType = {}));
    var NotificationStatus;
    (function (NotificationStatus) {
        NotificationStatus[NotificationStatus["Pending"] = 0] = "Pending";
        NotificationStatus[NotificationStatus["Sent"] = 1] = "Sent";
        NotificationStatus[NotificationStatus["Read"] = 2] = "Read";
        NotificationStatus[NotificationStatus["Done"] = 3] = "Done";
        NotificationStatus[NotificationStatus["Removed"] = 4] = "Removed";
    })(NotificationStatus = apsEnums.NotificationStatus || (apsEnums.NotificationStatus = {}));
    var QualificationStatus;
    (function (QualificationStatus) {
        QualificationStatus[QualificationStatus["NotQualified"] = 0] = "NotQualified";
        QualificationStatus[QualificationStatus["Qualified"] = 1] = "Qualified";
    })(QualificationStatus = apsEnums.QualificationStatus || (apsEnums.QualificationStatus = {}));
    var Location;
    (function (Location) {
        Location[Location["None"] = 0] = "None";
        Location[Location["HotEnd"] = 1] = "HotEnd";
        Location[Location["ColdEnd"] = 2] = "ColdEnd";
    })(Location = apsEnums.Location || (apsEnums.Location = {}));
    var LocationType;
    (function (LocationType) {
        LocationType[LocationType["Plant"] = 1] = "Plant";
        LocationType[LocationType["Tank"] = 2] = "Tank";
        LocationType[LocationType["Shop"] = 3] = "Shop";
        LocationType[LocationType["Other"] = 4] = "Other";
    })(LocationType = apsEnums.LocationType || (apsEnums.LocationType = {}));
    var JobChangeType;
    (function (JobChangeType) {
        JobChangeType[JobChangeType["Unknown"] = 0] = "Unknown";
        JobChangeType[JobChangeType["Full"] = 1] = "Full";
        JobChangeType[JobChangeType["Mold"] = 2] = "Mold";
        JobChangeType[JobChangeType["Finish"] = 3] = "Finish";
    })(JobChangeType = apsEnums.JobChangeType || (apsEnums.JobChangeType = {}));
    var TimeUnits;
    (function (TimeUnits) {
        TimeUnits[TimeUnits["Minutes"] = 1] = "Minutes";
        TimeUnits[TimeUnits["Shift"] = 2] = "Shift";
        TimeUnits[TimeUnits["Hours"] = 3] = "Hours";
        TimeUnits[TimeUnits["Days"] = 4] = "Days";
        TimeUnits[TimeUnits["Weeks"] = 5] = "Weeks";
        TimeUnits[TimeUnits["Months"] = 6] = "Months";
    })(TimeUnits = apsEnums.TimeUnits || (apsEnums.TimeUnits = {}));
    var CheckListStatus;
    (function (CheckListStatus) {
        CheckListStatus[CheckListStatus["Pending"] = 0] = "Pending";
        CheckListStatus[CheckListStatus["Scheduled"] = 1] = "Scheduled";
        CheckListStatus[CheckListStatus["Partial"] = 2] = "Partial";
        CheckListStatus[CheckListStatus["Complete"] = 3] = "Complete";
        CheckListStatus[CheckListStatus["NotDone"] = 4] = "NotDone";
        CheckListStatus[CheckListStatus["Expired"] = 5] = "Expired";
    })(CheckListStatus = apsEnums.CheckListStatus || (apsEnums.CheckListStatus = {}));
    var CheckListResult;
    (function (CheckListResult) {
        CheckListResult[CheckListResult["Incomplete"] = 0] = "Incomplete";
        CheckListResult[CheckListResult["Pass"] = 1] = "Pass";
        CheckListResult[CheckListResult["Fail"] = 2] = "Fail";
    })(CheckListResult = apsEnums.CheckListResult || (apsEnums.CheckListResult = {}));
    var CheckListView;
    (function (CheckListView) {
        CheckListView[CheckListView["Scheduled"] = 1] = "Scheduled";
        CheckListView[CheckListView["Unscheduled"] = 2] = "Unscheduled";
        CheckListView[CheckListView["All"] = 3] = "All";
        CheckListView[CheckListView["Blocking"] = 4] = "Blocking";
    })(CheckListView = apsEnums.CheckListView || (apsEnums.CheckListView = {}));
    var CheckAdditionalData;
    (function (CheckAdditionalData) {
        CheckAdditionalData[CheckAdditionalData["None"] = 0] = "None";
        CheckAdditionalData[CheckAdditionalData["LineSelection"] = 1] = "LineSelection";
    })(CheckAdditionalData = apsEnums.CheckAdditionalData || (apsEnums.CheckAdditionalData = {}));
    var CheckListLevel;
    (function (CheckListLevel) {
        CheckListLevel[CheckListLevel["All"] = 1] = "All";
        CheckListLevel[CheckListLevel["Corporate"] = 2] = "Corporate";
        CheckListLevel[CheckListLevel["Plant"] = 3] = "Plant";
        CheckListLevel[CheckListLevel["Shop"] = 4] = "Shop";
    })(CheckListLevel = apsEnums.CheckListLevel || (apsEnums.CheckListLevel = {}));
    var CheckStatus;
    (function (CheckStatus) {
        CheckStatus[CheckStatus["Failed"] = 1] = "Failed";
        CheckStatus[CheckStatus["Passed"] = 2] = "Passed";
        CheckStatus[CheckStatus["NotDone"] = 3] = "NotDone";
        CheckStatus[CheckStatus["NotApplicable"] = 4] = "NotApplicable";
    })(CheckStatus = apsEnums.CheckStatus || (apsEnums.CheckStatus = {}));
    var CheckDataType;
    (function (CheckDataType) {
        CheckDataType[CheckDataType["Text"] = 1] = "Text";
        CheckDataType[CheckDataType["Integer"] = 2] = "Integer";
        CheckDataType[CheckDataType["Decimal"] = 3] = "Decimal";
        CheckDataType[CheckDataType["Boolean"] = 4] = "Boolean";
        CheckDataType[CheckDataType["DateTime"] = 5] = "DateTime";
        CheckDataType[CheckDataType["Percent"] = 6] = "Percent";
        CheckDataType[CheckDataType["Count"] = 7] = "Count";
        CheckDataType[CheckDataType["Instructions"] = 8] = "Instructions";
        CheckDataType[CheckDataType["DefectType"] = 9] = "DefectType";
    })(CheckDataType = apsEnums.CheckDataType || (apsEnums.CheckDataType = {}));
    var CheckEntry;
    (function (CheckEntry) {
        CheckEntry[CheckEntry["PerShop"] = 1] = "PerShop";
        CheckEntry[CheckEntry["PerMachine"] = 2] = "PerMachine";
        CheckEntry[CheckEntry["PerSection"] = 3] = "PerSection";
        CheckEntry[CheckEntry["PerCavity"] = 4] = "PerCavity";
        CheckEntry[CheckEntry["PerDrop"] = 5] = "PerDrop";
    })(CheckEntry = apsEnums.CheckEntry || (apsEnums.CheckEntry = {}));
    var CheckValueType;
    (function (CheckValueType) {
        CheckValueType[CheckValueType["Single"] = 1] = "Single";
        CheckValueType[CheckValueType["Sample"] = 2] = "Sample";
        CheckValueType[CheckValueType["Multiple"] = 3] = "Multiple";
        CheckValueType[CheckValueType["MultipleSample"] = 4] = "MultipleSample";
        CheckValueType[CheckValueType["Aggregate"] = 5] = "Aggregate";
        CheckValueType[CheckValueType["Range"] = 6] = "Range";
    })(CheckValueType = apsEnums.CheckValueType || (apsEnums.CheckValueType = {}));
    var GlobalNotificationType;
    (function (GlobalNotificationType) {
        GlobalNotificationType[GlobalNotificationType["EntireCompany"] = 1] = "EntireCompany";
        GlobalNotificationType[GlobalNotificationType["EntirePlant"] = 2] = "EntirePlant";
        GlobalNotificationType[GlobalNotificationType["EntireShop"] = 3] = "EntireShop";
        GlobalNotificationType[GlobalNotificationType["Individuals"] = 4] = "Individuals";
        GlobalNotificationType[GlobalNotificationType["ReleaseNotes"] = 5] = "ReleaseNotes";
    })(GlobalNotificationType = apsEnums.GlobalNotificationType || (apsEnums.GlobalNotificationType = {}));
    var Shift;
    (function (Shift) {
        Shift[Shift["First"] = 1] = "First";
        Shift[Shift["Second"] = 2] = "Second";
        Shift[Shift["Third"] = 4] = "Third";
    })(Shift = apsEnums.Shift || (apsEnums.Shift = {}));
    var SectionChangeStatus;
    (function (SectionChangeStatus) {
        SectionChangeStatus[SectionChangeStatus["Scheduled"] = 1] = "Scheduled";
        SectionChangeStatus[SectionChangeStatus["Completed"] = 2] = "Completed";
        SectionChangeStatus[SectionChangeStatus["JobEnded"] = 3] = "JobEnded";
        SectionChangeStatus[SectionChangeStatus["Skipped"] = 4] = "Skipped";
    })(SectionChangeStatus = apsEnums.SectionChangeStatus || (apsEnums.SectionChangeStatus = {}));
    var SectionChangeSections;
    (function (SectionChangeSections) {
        SectionChangeSections[SectionChangeSections["Number"] = 1] = "Number";
        SectionChangeSections[SectionChangeSections["Half"] = 2] = "Half";
        SectionChangeSections[SectionChangeSections["All"] = 3] = "All";
    })(SectionChangeSections = apsEnums.SectionChangeSections || (apsEnums.SectionChangeSections = {}));
    var SectionChangeOrder;
    (function (SectionChangeOrder) {
        SectionChangeOrder[SectionChangeOrder["Sequential"] = 1] = "Sequential";
        SectionChangeOrder[SectionChangeOrder["AlternateByHalf"] = 2] = "AlternateByHalf";
    })(SectionChangeOrder = apsEnums.SectionChangeOrder || (apsEnums.SectionChangeOrder = {}));
    var RoleFlags;
    (function (RoleFlags) {
        RoleFlags[RoleFlags["Admin"] = 1] = "Admin";
        RoleFlags[RoleFlags["QC"] = 2] = "QC";
        RoleFlags[RoleFlags["ShiftSupervisor"] = 4] = "ShiftSupervisor";
        RoleFlags[RoleFlags["Operator"] = 8] = "Operator";
        RoleFlags[RoleFlags["MorningMinutes"] = 16] = "MorningMinutes";
        RoleFlags[RoleFlags["SectionChanges"] = 32] = "SectionChanges";
        RoleFlags[RoleFlags["ReceiveNotifications"] = 64] = "ReceiveNotifications";
        RoleFlags[RoleFlags["ColdEndInspector"] = 72] = "ColdEndInspector",
        RoleFlags[RoleFlags["APSIOAdmin"] = 128] = "APSIOAdmin";
        RoleFlags[RoleFlags["EightHourSummary"] = 256] = "EightHourSummary";
        RoleFlags[RoleFlags["ScaleMode"] = 512] = "ScaleMode";
    })(RoleFlags = apsEnums.RoleFlags || (apsEnums.RoleFlags = {}));
    var UnqualificationScope;
    (function (UnqualificationScope) {
        UnqualificationScope[UnqualificationScope["None"] = 0] = "None";
        UnqualificationScope[UnqualificationScope["Cavity"] = 1] = "Cavity";
        UnqualificationScope[UnqualificationScope["Drop"] = 2] = "Drop";
        UnqualificationScope[UnqualificationScope["Section"] = 3] = "Section";
        UnqualificationScope[UnqualificationScope["Machine"] = 4] = "Machine";
    })(UnqualificationScope = apsEnums.UnqualificationScope || (apsEnums.UnqualificationScope = {}));
    var WellKnownCheckType;
    (function (WellKnownCheckType) {
        WellKnownCheckType[WellKnownCheckType["HotEndEfficiency"] = 1] = "HotEndEfficiency";
        WellKnownCheckType[WellKnownCheckType["ShopPackEfficiency"] = 2] = "ShopPackEfficiency";
        WellKnownCheckType[WellKnownCheckType["Weight"] = 3] = "Weight";
        WellKnownCheckType[WellKnownCheckType["ColdEndPackEfficiency"] = 4] = "ColdEndPackEfficiency";
        WellKnownCheckType[WellKnownCheckType["GobsProduced"] = 5] = "GobsProduced";
        WellKnownCheckType[WellKnownCheckType["LehrInput"] = 6] = "LehrInput";
        WellKnownCheckType[WellKnownCheckType["PackedCount"] = 7] = "PackedCount";
        WellKnownCheckType[WellKnownCheckType["LehrOutput"] = 32] = "LehrOutputFirstInspectionDatapoint";
        WellKnownCheckType[WellKnownCheckType["ColdEndInspectionLoss"] = 33] = "ColdEndInspectionLoss";
        WellKnownCheckType[WellKnownCheckType["ColdEndTotalLoss"] = 34] = "ColdEndTotalLoss";
        WellKnownCheckType[WellKnownCheckType["LehrOutputTotal"] = 35] = "LehrOutputTotal";
        WellKnownCheckType[WellKnownCheckType["HeReject"] = 36] = "HeReject";
    })(WellKnownCheckType = apsEnums.WellKnownCheckType || (apsEnums.WellKnownCheckType = {}));
    var WellKnownCheckList;
    (function (WellKnownCheckList) {
        WellKnownCheckList[WellKnownCheckList["CriticalDefectReport"] = 1] = "CriticalDefectReport";
        WellKnownCheckList[WellKnownCheckList["WareHeldReport"] = 2] = "WareHeldReport";
        WellKnownCheckList[WellKnownCheckList["TankMetrics"] = 3] = "TankMetrics";
        WellKnownCheckList[WellKnownCheckList["PlantMetrics"] = 4] = "PlantMetrics";
        WellKnownCheckList[WellKnownCheckList["HourlyDowntime"] = 5] = "HourlyDowntime";
    })(WellKnownCheckList = apsEnums.WellKnownCheckList || (apsEnums.WellKnownCheckList = {}));
    var AggregateFunction;
    (function (AggregateFunction) {
        AggregateFunction[AggregateFunction["Average"] = 1] = "Average";
        AggregateFunction[AggregateFunction["Sum"] = 2] = "Sum";
        AggregateFunction[AggregateFunction["Min"] = 3] = "Min";
        AggregateFunction[AggregateFunction["Max"] = 4] = "Max";
        AggregateFunction[AggregateFunction["Cumulation"] = 5] = "Cumulation";
    })(AggregateFunction = apsEnums.AggregateFunction || (apsEnums.AggregateFunction = {}));
    var ChatItemType;
    (function (ChatItemType) {
        ChatItemType[ChatItemType["Chat"] = 1] = "Chat";
        ChatItemType[ChatItemType["Defect"] = 2] = "Defect";
        ChatItemType[ChatItemType["ToolChange"] = 3] = "ToolChange";
        ChatItemType[ChatItemType["Downtime"] = 4] = "Downtime";
    })(ChatItemType = apsEnums.ChatItemType || (apsEnums.ChatItemType = {}));
    var CheckMetaData;
    (function (CheckMetaData) {
        CheckMetaData[CheckMetaData["DefectType"] = 1] = "DefectType";
        CheckMetaData[CheckMetaData["Location"] = 2] = "Location";
        CheckMetaData[CheckMetaData["WhereFound"] = 3] = "WhereFound";
        CheckMetaData[CheckMetaData["JobItem"] = 4] = "JobItem";
        CheckMetaData[CheckMetaData["MoldNumber"] = 5] = "MoldNumber";
        CheckMetaData[CheckMetaData["Section"] = 6] = "Section";
        CheckMetaData[CheckMetaData["TimeFound"] = 7] = "TimeFound";
        CheckMetaData[CheckMetaData["Shop"] = 8] = "Shop";
        CheckMetaData[CheckMetaData["CreatedBy"] = 9] = "CreatedBy";
        CheckMetaData[CheckMetaData["TimeCorrected"] = 10] = "TimeCorrected";
        CheckMetaData[CheckMetaData["RootCause"] = 11] = "RootCause";
        CheckMetaData[CheckMetaData["Fix"] = 12] = "Fix";
        CheckMetaData[CheckMetaData["ShiftLetter"] = 13] = "ShiftLetter";
        CheckMetaData[CheckMetaData["TankMetricsPull"] = 14] = "TankMetricsPull";
        CheckMetaData[CheckMetaData["TankMetricsCullet"] = 15] = "TankMetricsCullet";
        CheckMetaData[CheckMetaData["TankMetricsGas"] = 16] = "TankMetricsGas";
        CheckMetaData[CheckMetaData["TankMetricsAir"] = 17] = "TankMetricsAir";
        CheckMetaData[CheckMetaData["TankMetricsBoost"] = 18] = "TankMetricsBoost";
        CheckMetaData[CheckMetaData["TankMetricsBWOPT"] = 19] = "TankMetricsBWOPT";
        CheckMetaData[CheckMetaData["TankMetricsBottom3"] = 20] = "TankMetricsBottom3";
        CheckMetaData[CheckMetaData["TankMetricsThroat"] = 21] = "TankMetricsThroat";
        CheckMetaData[CheckMetaData["TankMetricsSeeds"] = 22] = "TankMetricsSeeds";
        CheckMetaData[CheckMetaData["TankMetricsGasEnergy"] = 23] = "TankMetricsGasEnergy";
        CheckMetaData[CheckMetaData["TankMetricsElectricEnergy"] = 24] = "TankMetricsElectricEnergy";
        CheckMetaData[CheckMetaData["TankMetricsNOx"] = 25] = "TankMetricsNOx";
        CheckMetaData[CheckMetaData["TankMetricsSOx"] = 26] = "TankMetricsSOx";
        CheckMetaData[CheckMetaData["TankMetricsGlassDensity"] = 27] = "TankMetricsGlassDensity";
        CheckMetaData[CheckMetaData["TankMetricsCord"] = 28] = "TankMetricsCord";
        CheckMetaData[CheckMetaData["TankMetricsTransmissionAmber"] = 29] = "TankMetricsTransmissionAmber";
        CheckMetaData[CheckMetaData["TankMetricsColorFlint"] = 30] = "TankMetricsColorFlint";
        CheckMetaData[CheckMetaData["TankMetricsPressure"] = 31] = "TankMetricsPressure";
        CheckMetaData[CheckMetaData["TankMetricsBatchLine"] = 32] = "TankMetricsBatchLine";
        CheckMetaData[CheckMetaData["TankMetricsBatchMoisture"] = 33] = "TankMetricsBatchMoisture";        
    })(CheckMetaData = apsEnums.CheckMetaData || (apsEnums.CheckMetaData = {}));
    var DowntimeType;
    (function (DowntimeType) {
        DowntimeType[DowntimeType["All"] = 0] = "All";
        DowntimeType[DowntimeType["Preventative"] = 1] = "Preventative";
        DowntimeType[DowntimeType["Corrective"] = 2] = "Corrective";
    })(DowntimeType = apsEnums.DowntimeType || (apsEnums.DowntimeType = {}));
    var DowntimeLocation;
    (function (DowntimeLocation) {
        DowntimeLocation[DowntimeLocation["All"] = 0] = "All";
        DowntimeLocation[DowntimeLocation["Machine"] = 1] = "Machine";
        DowntimeLocation[DowntimeLocation["Section"] = 2] = "Section";
    })(DowntimeLocation = apsEnums.DowntimeLocation || (apsEnums.DowntimeLocation = {}));
    var DowntimeOrder;
    (function (DowntimeOrder) {
        DowntimeOrder[DowntimeOrder["Time"] = 1] = "Time";
        DowntimeOrder[DowntimeOrder["Type"] = 2] = "Type";
        DowntimeOrder[DowntimeOrder["Duration"] = 3] = "Duration";
        DowntimeOrder[DowntimeOrder["Reason"] = 4] = "Reason";
        DowntimeOrder[DowntimeOrder["Comment"] = 5] = "Comment";
        DowntimeOrder[DowntimeOrder["Tool"] = 6] = "Tool";
        DowntimeOrder[DowntimeOrder["Machine"] = 7] = "Machine";
        DowntimeOrder[DowntimeOrder["Location"] = 8] = "Location";
    })(DowntimeOrder = apsEnums.DowntimeOrder || (apsEnums.DowntimeOrder = {}));
    var TopDefectsFilter;
    (function (TopDefectsFilter) {
        TopDefectsFilter[TopDefectsFilter["Top10Defects"] = 1] = "Top10Defects";
        TopDefectsFilter[TopDefectsFilter["CriticalDefects"] = 2] = "CriticalDefects";
        TopDefectsFilter[TopDefectsFilter["AllDefects"] = 3] = "AllDefects";
    })(TopDefectsFilter = apsEnums.TopDefectsFilter || (apsEnums.TopDefectsFilter = {}));
    var CheckListReportFilter;
    (function (CheckListReportFilter) {
        CheckListReportFilter[CheckListReportFilter["AllCheckLists"] = 1] = "AllCheckLists";
        CheckListReportFilter[CheckListReportFilter["FailedOnly"] = 2] = "FailedOnly";
        CheckListReportFilter[CheckListReportFilter["WithComments"] = 3] = "WithComments";
    })(CheckListReportFilter = apsEnums.CheckListReportFilter || (apsEnums.CheckListReportFilter = {}));
    var EventAction;
    (function (EventAction) {
        EventAction[EventAction["Add"] = 1] = "Add";
        EventAction[EventAction["Update"] = 2] = "Update";
        EventAction[EventAction["Delete"] = 3] = "Delete";
    })(EventAction = apsEnums.EventAction || (apsEnums.EventAction = {}));
    var DefectOrder;
    (function (DefectOrder) {
        DefectOrder[DefectOrder["Time"] = 1] = "Time";
        DefectOrder[DefectOrder["Severity"] = 2] = "Severity";
        DefectOrder[DefectOrder["Location"] = 3] = "Location";
        DefectOrder[DefectOrder["Mold"] = 4] = "Mold";
        DefectOrder[DefectOrder["WhereFound"] = 5] = "WhereFound";
        DefectOrder[DefectOrder["PlantAndShop"] = 6] = "PlantAndShop";
    })(DefectOrder = apsEnums.DefectOrder || (apsEnums.DefectOrder = {}));
    var EquipmentType;
    (function (EquipmentType) {
        EquipmentType[EquipmentType["Scale"] = 1] = "Scale";
        EquipmentType[EquipmentType["PLC"] = 2] = "PLC";
        EquipmentType[EquipmentType["WSI"] = 3] = "WSI";
        EquipmentType[EquipmentType["WBF"] = 4] = "WBF";
        EquipmentType[EquipmentType["HEYE"] = 5] = "HEYE";
        EquipmentType[EquipmentType["SerialConverter"] = 6] = "SerialConverter";
        EquipmentType[EquipmentType["AIServer"] = 7] = "AIServer";
        EquipmentType[EquipmentType["CheckDetector"] = 8] = "CheckDetector";
        EquipmentType[EquipmentType["RaspberryPi"] = 9] = "RaspberryPi";
        EquipmentType[EquipmentType["MX4"] = 10] = "MX4";
        EquipmentType[EquipmentType["Multi"] = 11] = "Multi";
        EquipmentType[EquipmentType["Mcal"] = 12] = "Mcal";
        EquipmentType[EquipmentType["FlexBC"] = 13] = "FlexBC";
        EquipmentType[EquipmentType["FlexM"] = 14] = "FlexM";
        EquipmentType[EquipmentType["FlexIS"] = 15] = "FlexIS";
        EquipmentType[EquipmentType["LineServer"] = 16] = "LineServer";
        EquipmentType[EquipmentType["KepC"] = 17] = "KepC";
        EquipmentType[EquipmentType["SqlC"] = 18] = "SqlC";
        EquipmentType[EquipmentType["PPCScale"] = 19] = "PPCScale";
        EquipmentType[EquipmentType["SqlM"] = 20] = "SqlM";
        EquipmentType[EquipmentType["WSG"] = 21] = "WSG";
        EquipmentType[EquipmentType["WFG"] = 22] = "WFG";
        EquipmentType[EquipmentType["CBIT"] = 23] = "CBIT";
        EquipmentType[EquipmentType["Cyclops"] = 24] = "Cyclops";
    })(EquipmentType = apsEnums.EquipmentType || (apsEnums.EquipmentType = {}));
    var LineEquipmentType;
    (function (LineEquipmentType) {
        LineEquipmentType[LineEquipmentType["InspectReject"] = 1] = "InspectReject";
        LineEquipmentType[LineEquipmentType["WSI"] = 2] = "WSI";
        LineEquipmentType[LineEquipmentType["Counter"] = 3] = "Counter";
        LineEquipmentType[LineEquipmentType["WBF"] = 4] = "WBF";
        LineEquipmentType[LineEquipmentType["HEYE"] = 5] = "HEYE";
        LineEquipmentType[LineEquipmentType["CheckDetector"] = 6] = "CheckDetector";
        LineEquipmentType[LineEquipmentType["Palletizer"] = 7] = "Palletizer";
        LineEquipmentType[LineEquipmentType["MX4"] = 8] = "MX4";
        LineEquipmentType[LineEquipmentType["Multi"] = 9] = "Multi";
        LineEquipmentType[LineEquipmentType["Mcal"] = 10] = "Mcal";
        LineEquipmentType[LineEquipmentType["FlexBC"] = 11] = "FlexBC";   
        LineEquipmentType[LineEquipmentType["FlexM"] = 12] = "FlexM";           
        LineEquipmentType[LineEquipmentType["FlexIS"] = 13] = "FlexIS";    
    })(LineEquipmentType = apsEnums.LineEquipmentType || (apsEnums.LineEquipmentType = {}));
    var ScaleMode;
    (function (ScaleMode) {
        ScaleMode[ScaleMode["Prompted"] = 1] = "Prompted";
        ScaleMode[ScaleMode["Manual"] = 2] = "Manual";
    })(ScaleMode = apsEnums.ScaleMode || (apsEnums.ScaleMode = {}));
    var ScaleDisplay;
    (function (ScaleDisplay) {
        ScaleDisplay[ScaleDisplay["DifferenceFromTarget"] = 0] = "DifferenceFromTarget";
        ScaleDisplay[ScaleDisplay["ActualWeight"] = 1] = "ActualWeight";
    })(ScaleDisplay = apsEnums.ScaleDisplay || (apsEnums.ScaleDisplay = {}));
    var DataPointType;
    var SensorType;
    (function (SensorType) {
        SensorType[SensorType["PlcCounter"] = 1] = "PlcCounter";
        SensorType[SensorType["Monitoring"] = 2] = "Monitoring";
        SensorType[SensorType["Alarm"] = 3] = "Alarm";
        SensorType[SensorType["MachineSpeed"] = 4] = "MachineSpeed";
    })(SensorType = apsEnums.SensorType || (apsEnums.SensorType = {}));
    (function (DataPointType) {
        DataPointType[DataPointType["Inspect"] = 1] = "Inspect";
        DataPointType[DataPointType["Reject"] = 2] = "Reject";
        DataPointType[DataPointType["Alarm"] = 3] = "Alarm";
        DataPointType[DataPointType["NonInspect"] = 4] = "NonInspect";
        DataPointType[DataPointType["Monitoring"] = 5] = "Monitoring";
    })(DataPointType = apsEnums.DataPointType || (apsEnums.DataPointType = {}));
    var DataPointConfigType;
    (function (DataPointConfigType) {
        DataPointConfigType[DataPointConfigType["PlcCounter"] = 1] = "PlcCounter";
        DataPointConfigType[DataPointConfigType["Formula"] = 2] = "Formula";
        DataPointConfigType[DataPointConfigType["WsiCounter"] = 3] = "WsiCounter";
        DataPointConfigType[DataPointConfigType["HEYECounter"] = 4] = "HEYECounter";
        DataPointConfigType[DataPointConfigType["CheckDetectorCounter"] = 5] = "CheckDetectorCounter";
        DataPointConfigType[DataPointConfigType["RaspberryPiCounter"] = 6] = "RaspberryPiCounter";
        DataPointConfigType[DataPointConfigType["MX4Counter"] = 7] = "MX4Counter";
        DataPointConfigType[DataPointConfigType["MultiCounter"] = 8] = "MultiCounter";
        DataPointConfigType[DataPointConfigType["McalCounter"] = 9] = "McalCounter";
        DataPointConfigType[DataPointConfigType["FlexBCCounter"] = 10] = "FlexBCCounter";     
        DataPointConfigType[DataPointConfigType["FlexMCounter"] = 11] = "FlexMCounter";           
        DataPointConfigType[DataPointConfigType["FlexISCounter"] = 12] = "FlexISCounter";   
        DataPointConfigType[DataPointConfigType["CounterSimple"] = 13] = "CounterSimple";   
        DataPointConfigType[DataPointConfigType["PPCScale"] = 14] = "PPCScale";
        DataPointConfigType[DataPointConfigType["CBITCounter"] = 15] = "CBITCounter";   
        DataPointConfigType[DataPointConfigType["CyclopsCounter"] =  16] = "CyclopsCounter";
    })(DataPointConfigType = apsEnums.DataPointConfigType || (apsEnums.DataPointConfigType = {}));
    var VariableType;
    (function (VariableType) {
        VariableType[VariableType["DataPoint"] = 1] = "DataPoint";
        VariableType[VariableType["NumberOfGobs"] = 2] = "NumberOfGobs";
        VariableType[VariableType["NumberOfMachines"] = 3] = "NumberOfMachines";
        VariableType[VariableType["ContainerSpeed"] = 4] = "ContainerSpeed";
        VariableType[VariableType["ContainersPerCase"] = 5] = "ContainersPerCase";
        VariableType[VariableType["CasesPerCycle"] = 6] = "CasesPerCycle";
        VariableType[VariableType["ContainersPerTier"] = 7] = "ContainersPerTier";
        VariableType[VariableType["TiersPerPallet"] = 8] = "TiersPerPallet";
    })(VariableType = apsEnums.VariableType || (apsEnums.VariableType = {}));
    var WXILogEventType;
    (function (WXILogEventType) {
        WXILogEventType[WXILogEventType["Message"] = 1] = "Message";
        WXILogEventType[WXILogEventType["ConsecutiveRejects"] = 2] = "ConsecutiveRejects";
        WXILogEventType[WXILogEventType["ExcessiveRejects"] = 4] = "ExcessiveRejects";
        WXILogEventType[WXILogEventType["LightControlStandard"] = 8] = "LightControlStandard";
        WXILogEventType[WXILogEventType["LightControlStress"] = 16] = "LightControlStress";
        WXILogEventType[WXILogEventType["MissingAcquisition"] = 32] = "MissingAcquisition";
        WXILogEventType[WXILogEventType["MissingRejectSensorStandard"] = 64] = "MissingRejectSensorStandard";
        WXILogEventType[WXILogEventType["MissingRejectSensorMode"] = 128] = "MissingRejectSensorMode";
        WXILogEventType[WXILogEventType["RejectConfirm"] = 256] = "RejectConfirm";
        WXILogEventType[WXILogEventType["AcquisitionTerminated"] = 512] = "AcquisitionTerminated";
        WXILogEventType[WXILogEventType["AcquisitionTooShort"] = 1024] = "AcquisitionTooShort";
        WXILogEventType[WXILogEventType["CameraDisconnected"] = 2048] = "CameraDisconnected";
        WXILogEventType[WXILogEventType["CameraNotAvailable"] = 4096] = "CameraNotAvailable";
        WXILogEventType[WXILogEventType["ContainerMonitorTerminated"] = 8192] = "ContainerMonitorTerminated";
        WXILogEventType[WXILogEventType["IoNotAvailable"] = 16384] = "IoNotAvailable";
        WXILogEventType[WXILogEventType["SystemNotFullyOperational"] = 32768] = "SystemNotFullyOperational";
        WXILogEventType[WXILogEventType["InspectionTerminated"] = 65536] = "InspectionTerminated";
        WXILogEventType[WXILogEventType["SmartKeyReaderMissing"] = 131072] = "SmartKeyReaderMissing";
        WXILogEventType[WXILogEventType["MissingMoldData"] = 262144] = "MissingMoldData";
        WXILogEventType[WXILogEventType["ConveyerTooFast"] = 524288] = "ConveyerTooFast";
        WXILogEventType[WXILogEventType["CameraOffset"] = 1048576] = "CameraOffset";
        WXILogEventType[WXILogEventType["ExitProgramMode"] = 2097152] = "ExitProgramMode";
        WXILogEventType[WXILogEventType["ActiveConfigLoaded"] = 4194304] = "ActiveConfigLoaded";
        WXILogEventType[WXILogEventType["ParameterChanges"] = 8388608] = "ParameterChanges";
        WXILogEventType[WXILogEventType["Reset"] = 16777216] = "Reset";
    })(WXILogEventType = apsEnums.WXILogEventType || (apsEnums.WXILogEventType = {}));
    var WXIEventSeverity;
    (function (WXIEventSeverity) {
        WXIEventSeverity[WXIEventSeverity["Information"] = 1] = "Information";
        WXIEventSeverity[WXIEventSeverity["HardwareMalfunction"] = 2] = "HardwareMalfunction";
        WXIEventSeverity[WXIEventSeverity["SuspiciousReading"] = 4] = "SuspiciousReading";
    })(WXIEventSeverity = apsEnums.WXIEventSeverity || (apsEnums.WXIEventSeverity = {}));
    var EquipmentTimedEventMode;
    (function (EquipmentTimedEventMode) {
        EquipmentTimedEventMode[EquipmentTimedEventMode["None"] = 0] = "None";
        EquipmentTimedEventMode[EquipmentTimedEventMode["OnTheHour"] = 1] = "OnTheHour";
        EquipmentTimedEventMode[EquipmentTimedEventMode["Interval"] = 2] = "Interval";
        EquipmentTimedEventMode[EquipmentTimedEventMode["JobRun"] = 3] = "JobRun";
        EquipmentTimedEventMode[EquipmentTimedEventMode["ShiftInterval"] = 4] = "ShiftInterval";
    })(EquipmentTimedEventMode = apsEnums.EquipmentTimedEventMode || (apsEnums.EquipmentTimedEventMode = {}));
    var EquipmentHealthState;
    (function (EquipmentHealthState) {
        EquipmentHealthState[EquipmentHealthState["Unknown"] = 0] = "Unknown";
        EquipmentHealthState[EquipmentHealthState["Good"] = 1] = "Good";
        EquipmentHealthState[EquipmentHealthState["Warning"] = 2] = "Warning";
        EquipmentHealthState[EquipmentHealthState["Error"] = 3] = "Error";
        EquipmentHealthState[EquipmentHealthState["Inactive"] = 4] = "Inactive";
    })(EquipmentHealthState = apsEnums.EquipmentHealthState || (apsEnums.EquipmentHealthState = {}));
    var CountInterval;
    (function (CountInterval) {
        CountInterval[CountInterval["Minute"] = 1] = "Minute";
        CountInterval[CountInterval["TenMinutes"] = 2] = "TenMinutes";
        CountInterval[CountInterval["Hour"] = 3] = "Hour";
        CountInterval[CountInterval["Shift"] = 4] = "Shift";
        CountInterval[CountInterval["Day"] = 5] = "Day";
    })(CountInterval = apsEnums.CountInterval || (apsEnums.CountInterval = {}));
    var WSIDefect;
    (function (WSIDefect) {
        WSIDefect[WSIDefect["Blemish"] = 1] = "Blemish";
        WSIDefect[WSIDefect["Method1"] = 2] = "Method1";
        WSIDefect[WSIDefect["Method2"] = 3] = "Method2";
        WSIDefect[WSIDefect["Diameter"] = 4] = "Diameter";
        WSIDefect[WSIDefect["Lean"] = 5] = "Lean";
        WSIDefect[WSIDefect["Height"] = 6] = "Height";
        WSIDefect[WSIDefect["UnderHeight"] = 7] = "UnderHeight";
        WSIDefect[WSIDefect["OverHeight"] = 8] = "OverHeight";
        WSIDefect[WSIDefect["Stress"] = 9] = "Stress";
        WSIDefect[WSIDefect["Cosmetic"] = 10] = "Cosmetic";
    })(WSIDefect = apsEnums.WSIDefect || (apsEnums.WSIDefect = {}));
    var CheckDetectorCounterType;
    (function (CheckDetectorCounterType) {
        CheckDetectorCounterType[CheckDetectorCounterType["Select1"] = 1] = "Select1";
        CheckDetectorCounterType[CheckDetectorCounterType["Select2"] = 2] = "Select2";
        CheckDetectorCounterType[CheckDetectorCounterType["Check"] = 3] = "Check";
        CheckDetectorCounterType[CheckDetectorCounterType["Dip"] = 4] = "Dip";
        CheckDetectorCounterType[CheckDetectorCounterType["Gauger"] = 5] = "Gauger";
        CheckDetectorCounterType[CheckDetectorCounterType["MNR"] = 6] = "MNR";
        CheckDetectorCounterType[CheckDetectorCounterType["WallThickness"] = 7] = "WallThickness";
        CheckDetectorCounterType[CheckDetectorCounterType["Bottom"] = 8] = "Bottom";
        CheckDetectorCounterType[CheckDetectorCounterType["Sidewall"] = 9] = "Sidewall";
    })(CheckDetectorCounterType = apsEnums.CheckDetectorCounterType || (apsEnums.CheckDetectorCounterType = {}));
    var CheckDetectorVersion;
    (function (CheckDetectorVersion) {
        CheckDetectorVersion[CheckDetectorVersion["V420"] = 0] = "V420";
        CheckDetectorVersion[CheckDetectorVersion["V309"] = 1] = "V309";
    })(CheckDetectorVersion = apsEnums.CheckDetectorVersion || (apsEnums.CheckDetectorVersion = {}));
    var CountRejectPercent;
    (function (CountRejectPercent) {
        CountRejectPercent[CountRejectPercent["PercentOfInspection"] = 0] = "PercentOfInspection";
        CountRejectPercent[CountRejectPercent["PercentOfGobsProduced"] = 1] = "PercentOfGobsProduced";
    })(CountRejectPercent = apsEnums.CountRejectPercent || (apsEnums.CountRejectPercent = {}));
    var PalletizerSignalType;
    (function (PalletizerSignalType) {
        PalletizerSignalType[PalletizerSignalType["PerPallet"] = 1] = "PerPallet";
        PalletizerSignalType[PalletizerSignalType["PerTier"] = 2] = "PerTier";
    })(PalletizerSignalType = apsEnums.PalletizerSignalType || (apsEnums.PalletizerSignalType = {}));
    var LogLevel;
    (function (LogLevel) {
        LogLevel[LogLevel["Verbose"] = 1] = "Verbose";
        LogLevel[LogLevel["Debug"] = 2] = "Debug";
        LogLevel[LogLevel["Info"] = 3] = "Info";
        LogLevel[LogLevel["Warning"] = 4] = "Warning";
        LogLevel[LogLevel["Error"] = 5] = "Error";
    })(LogLevel = apsEnums.LogLevel || (apsEnums.LogLevel = {}));
    var FlexISDataPointAliases;
    (function (FlexISDataPointAliases) {
        FlexISDataPointAliases[FlexISDataPointAliases["MC_CUT"] = 1] = "MC_CUT";
        FlexISDataPointAliases[FlexISDataPointAliases["MC_CUT_SC_X"]= 2] = "MC_CUT_SC_X";
        FlexISDataPointAliases[FlexISDataPointAliases["MC_NOT_CUT"]= 3] = "MC_NOT_CUT";
        FlexISDataPointAliases[FlexISDataPointAliases["MC_NOT_CUT_SC_X"]= 4] = "MC_NOT_CUT_SC_X";
        FlexISDataPointAliases[FlexISDataPointAliases["MC_DEL"]= 5] = "MC_DEL";
        FlexISDataPointAliases[FlexISDataPointAliases["MC_DEL_SC_X"]= 6] = "MC_DEL_SC_X";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_REQ"]= 7] = "SC_REQ";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_NRQ"]= 8] = "SC_NRQ";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_DEL"]= 9] = "SC_DEL";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_LOST_MS"]= 10] = "SC_LOST_MS";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_NRQ_STOP"]= 11] = "SC_NRQ_STOP";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_NRQ_DEL_OFF"]= 12] = "SC_NRQ_DEL_OFF";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_NRQ_MAN_SWAB"]= 13] = "SC_NRQ_MAN_SWAB";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_NRQ_ALT_SWAB"]= 14] = "SC_NRQ_ALT_SWAB";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_COMO"]= 15] = "SC_RJ_COMO";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_MAN_SWAB"]= 16] = "SC_RJ_MAN_SWAB";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_ALT_SWAB"]= 17] = "SC_RJ_ALT_SWAB";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_WHC"]= 18] = "SC_RJ_WHC";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ"]= 19] = "SC_RJ";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_DWR_WIDE"]= 20] = "WHC_DWR_WIDE";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_DWR_THIN"]= 21] = "WHC_DWR_THIN";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_DWR_SPACE"]= 22] = "WHC_DWR_SPACE";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_DWR_OUT"]= 23] = "WHC_DWR_OUT";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_USR_CNT_1"]= 24] = "WHC_USR_CNT_1";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_USR_CNT_2"]= 25] = "WHC_USR_CNT_2";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_USR_CNT_3"]= 26] = "WHC_USR_CNT_3";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_STA_CON"] = 27] = "SC_RJ_STA_CON";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_STA_CON_BK_X"] = 28] = "SC_RJ_STA_CON_BK_X";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_STA_CON_BW_X"] = 29] = "SC_RJ_STA_CON_BW_X";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_SRV"] = 30] = "SC_RJ_SRV";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_SRV_X"] = 31] = "SC_RJ_SRV_X";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_BK"] = 32] = "SC_RJ_BK";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_BW"] = 33] = "SC_RJ_BW";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_BK_X"] = 34] = "SC_RJ_BK_X";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_BW_X"] = 35] = "SC_RJ_BW_X";

    })(FlexISDataPointAliases = apsEnums.FlexISDataPointAliases || (apsEnums.FlexISDataPointAliases = {}));
    var ExcelExports;
    (function (ExcelExports) {
        ExcelExports[ExcelExports["ProductionReport"] = 0] = "ProductionReport";
    })(ExcelExports = apsEnums.ExcelExports || (apsEnums.ExcelExports = {}));
    var TiamaMultiMcalProtocol;
    (function (TiamaMultiMcalProtocol) {
        TiamaMultiMcalProtocol[TiamaMultiMcalProtocol["BaseVersion"] = 0] = "BaseVersion";
        TiamaMultiMcalProtocol[TiamaMultiMcalProtocol["Version_4_2"] = 1] = "Version_4_2";
        TiamaMultiMcalProtocol[TiamaMultiMcalProtocol["Version_10_1"] = 2] = "Version_10_1";
    })(TiamaMultiMcalProtocol = apsEnums.TiamaMultiMcalProtocol || (apsEnums.TiamaMultiMcalProtocol = {}));
})(apsEnums = exports.apsEnums || (exports.apsEnums = {}));


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dto/aps.enums.js
// module id = 5
// module chunks = 0